import { Button, Divider as BaseDivider, styled, Icon, css } from '@innowise-group/mui-kit';
import { ContactsFieldsDiff, PrimitiveFieldsDiff, LinksDataDiff } from '../../../diff-variants';

export const DeleteLinkContainer = styled.div`
  margin-top: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const AddButton = styled(Button)`
  grid-column: 4;
  justify-self: end;
`;

export const DeleteButton = styled(Button)`
  align-self: end;
  &.MuiButton-root {
    position: absolute;
    top: -22px;
    right: 0;
  }
  &.MuiButton-text {
    padding: 6px 8px !important;
  }
`;

export const DeleteIcon = styled(Icon)`
  & svg {
    transition: 0.2s;
    transform: rotate(45deg);
    fill: ${({ theme }) => theme.palette.state.error.pressed};
  }
`;

export const PlusIcon = styled(Icon)`
  & svg {
    transition: 0.2s;
    fill: ${({ theme }) => theme.palette.state.error.pressed};
  }
`;

export const Divider = styled(BaseDivider)`
  grid-column: 1 / span 4;
`;

export const BoxForDiffConsolidation = styled.div`
  position: relative;
  display: grid;
`;

export const BoxForLinksDiffConsolidation = styled(BoxForDiffConsolidation)<{ $fullWidth: boolean }>`
  gap: 1.75rem;
  ${({ $fullWidth }) => ({
    gridColumn: $fullWidth ? '1/-1' : '1/3',
    gridTemplateColumns: $fullWidth ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
  })}
`;

const commonDiffElementsPosition = css`
  top: 8px;
`;

export const CustomContactsFieldsDiff = styled(ContactsFieldsDiff)`
  ${commonDiffElementsPosition}
`;

export const CustomPrimitiveFieldsDiff = styled(PrimitiveFieldsDiff)`
  ${commonDiffElementsPosition}
`;

export const CustomLinksDataDiff = styled(LinksDataDiff)`
  top: 28px;
`;
